class FormController {
  submit() {
    this.onSubmit();
  }

  reset() {
  	this.onReset();
  }
}

export default FormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/overview/component/form.controller.js